<div class="grid m-1 h-full">
  <div class="col-12 lg:col-8 flex align-items-start px-2 flex-column">
    <div
      class="text-2xl font-bold color-primary grid w-full text-center section-title my-3"
    >
      <span class="col-offset-4 col-4"> vGPS </span>
      <span class="col-4 text-right">
        <p-button
          label="Close"
          [outlined]="true"
          severity="danger"
          (click)="closeGuidedForm()"
        ></p-button>
      </span>
    </div>
    <div
      [ngClass]="{
        'color-gray text-xl font-semibold question-title pl-2 mb-2': true,
        'w-full': CurrentQuestion.type === 'sub-form'
      }"
    >
      {{ CurrentQuestion.title }}
    </div>
    <div *ngIf="CurrentQuestion.type === 'mcq'; else subform">
      <div
        *ngFor="let option of CurrentQuestion.options; let i = index"
        (click)="optionSelected(option)"
        class="cursor-pointer p-1 text-left text-lg gps-option font-semibold"
      >
        {{ i + 1 }}. {{ option.label }}
      </div>
    </div>
    <ng-template #subform>
      <div *ngIf="CurrentQuestion.type === 'sub-form'" class="w-full">
        <via-dynamic-form
          [formFields]="CurrentQuestion.fields"
          (submitForm)="subFormSubmitted($event)"
          submitButtonText="Next"
        >
        </via-dynamic-form>
      </div>
    </ng-template>
  </div>
  <div class="col-12 lg:col-4 progress-container">
    <div
      class="text-2xl font-bold color-primary grid w-full text-center section-title my-3"
    >
      <span class="col-12"> Progress </span>
    </div>
    <div
      *ngFor="let question of AnsweredQuestions; let i = index"
      (click)="changeQuestion(i)"
      class="cursor-pointer my-2"
    >
      <span class="p-1 text-center text-lg font-semibold color-gray">
        {{ i + 1 }}. {{ question.title }}
      </span>
      <span
        class="color-primary text-lg font-bold"
        *ngIf="question.type === 'mcq'"
      >
        {{ answers[i].label }}
      </span>
      <span
        class="color-primary text-lg font-bold"
        *ngIf="question.type === 'sub-form'"
      >
        Filled
      </span>
    </div>
  </div>
</div>
